// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-element{display:flex;height:100%;width:100%;box-sizing:border-box;transition:opacity 0.3s linear;text-decoration:none}.button-element__icon{height:auto}a.button-element:hover{opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
